import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import ReelFarmTemplate from "~/components/Templates/ReelFarmTemplate"
import AppLayout from "~/layouts/AppLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

const CreateVideoPage = () => {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "GenZ Avatars" }]
  const genzAvatarsSEO = getPageSEO("templates/genz-avatars")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      <CustomHead
        title={genzAvatarsSEO.title}
        description={genzAvatarsSEO.description}
        keywords={genzAvatarsSEO.keywords}
        pageType={genzAvatarsSEO.pageType}
        url="https://vidmax.ai/templates/genz-avatars"
      />

      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody className="sm:[--content-max-width:500px] md:[--content-max-width:700px] xl:[--content-max-width:960px]">
        <ReelFarmTemplate />
      </AixContentBody>
    </>
  )
}

function CreateVideoPageWrapper() {
  return (
    <AppLayout>
      <CreateVideoPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/templates/genz-avatars")({
  component: CreateVideoPageWrapper,
})
